export const AdditionalQuotationStatuses = {
    APPROVED: 4,
    SENT: 3,
    CANCEL: 2,
    NEW: 1
}